import { Alert } from 'antd';

import { useAuthSession } from '@/entities/auth/api/hooks';
import { PageSpinner } from '@/shared/ui/PageSpinner';
import { MedicalEmployeeDetail } from '@/pages/Medical/EmployeeMedicalCard';

/**
 * US-2.1 / US-2.3: персональная страница медосмотров сотрудника.
 * Данные: GET /v1/medical-checks/employees/{employeeId} (зона видимости по роли на бэкенде).
 * Вкладка показывается только если роль получает section `my_exams` из GET /v1/medical-checks/sections.
 */
export function MyExamsTab() {
  const { data: auth, isLoading } = useAuthSession();

  if (isLoading) {
    return <PageSpinner />;
  }

  const employeeId = auth?.user.employee_id;
  if (!employeeId) {
    return (
      <Alert
        type="info"
        showIcon
        message="К учётной записи не привязана карточка сотрудника"
        description="Обратитесь к администратору, чтобы связать пользователя с записью в реестре персонала — тогда здесь отобразятся ваши медосмотры."
      />
    );
  }

  return (
    <>
      <MedicalEmployeeDetail employeeId={employeeId} showBack={false} />
    </>
  );
}
